<div class="hesitation-section-bg">
  <div class="hesitation-section-content">
    <h2 class="headline">Funktioniert das wirklich?</h2>
    <p class="subheadline">
      Ja, wir nehmen dich nur an, wenn du wirklich bereit bist, 100% zu geben. Erst dann bekommst du Zugriff auf das spezielle Wissen unserer Krypto-Genies!
    </p>
    <app-apply-button></app-apply-button>
  </div>
</div> 